const initialState = {
    filters: {}
};

export default function order_items(state = initialState, action = {}) {
    switch (action.type) {
        case 'UPDATE_ORDERS_ITEMS_FILTERS_FORM':
            return {
                ...state,
                filters: action.payload
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Items/reducers.js